import { MEMBER_STATUS } from "constants/member";

import { db, FieldValue } from 'helpers/firebase';
const serverTimestamp = FieldValue.serverTimestamp;

//CRUD /orgs/(org_id)/members/(uid)

export const addMember = (org_id, uid, userData) => {

  if (!org_id) {
    return Promise.reject('org_id is reuqired');
  }

  if (!uid) {
    return Promise.reject('uid is required');
  }

  const userRef = db.doc(`/users/${uid}`);
  return userRef.get()
    .then(docSnap => {
      if (!docSnap.exists) {
        return Promise.reject(new Error("No user found"));
      }
      const user = docSnap.data();
      const {
        name,
        birthday,
        gender,
        phone,
        profile_image_url,
      } = user;

      const memberRef = db.doc(`/orgs/${org_id}/members/${uid}`);
      return memberRef.set({
        name,
        birthday,
        gender,
        phone,
        profile_image_url,
        moved_in_at: serverTimestamp(),
        status: MEMBER_STATUS.NORMAL
      });
    })
}

export const getMember = (org_id, uid) => {

  if (!org_id) {
    return Promise.reject('org_id is reuqired');
  }

  if (!uid) {
    return Promise.reject('uid is required');
  }

  const memberRef = db.doc(`/orgs/${org_id}/members/${uid}`);
  return memberRef.get();
}

export const updateMember = (org_id, uid, params) => {
  if (!org_id) {
    return Promise.reject('org_id is reuqired');
  }

  if (!uid) {
    return Promise.reject('uid is required');
  }

  const memberRef = db.doc(`/orgs/${org_id}/members/${uid}`);
  return memberRef.update({
    ...params,
    modified_at: serverTimestamp()
  });
}


// deprecated: use deleteMemberAction instead. deleteMemberAction call http request deleteMember
// it also delete bigquery row.
export const deleteMember = (org_id, uid) => {
  if (!org_id) {
    return Promise.reject('org_id is reuqired');
  }

  if (!uid) {
    return Promise.reject('uid is required');
  }

  const memberRef = db.doc(`/orgs/${org_id}/members/${uid}`);
  return memberRef.update({
    status: MEMBER_STATUS.DELETED,
    modified_at: serverTimestamp()
  });
}

// collection
export const getMembers = (org_id) => {
  if (!org_id) {
    return Promise.reject(Error("org_id is reuqired"));
  }

  const membersRef = db.collection(`/orgs/${org_id}/members`);
  return membersRef.get()
    .then(colSnap => colSnap.docs)
}

export const getNormalMembersRef = (org_id) => {
  if (!org_id) {
    return Promise.reject(Error("org_id is reuqired"));
  }

  const membersRef = db
    .collection(`/orgs/${org_id}/members`)
    .where('status', '==', MEMBER_STATUS.NORMAL)
    .orderBy('moved_in_at', 'desc');
  return membersRef;
}

export const getAllMembersRef = (org_id) => {
  if (!org_id) {
    return Promise.reject(Error("org_id is reuqired"));
  }

  const membersRef = db.collection(`/orgs/${org_id}/members`).orderBy('moved_in_at', 'desc');
  return membersRef;
}

export const getCounselorsRef = (org_id) => {
  if (!org_id) {
    return Promise.reject(Error("org_id is reuqired"));
  }

  const counselorsRef = db
    .collection(`/orgs/${org_id}/members`)
    .where("is_counselor", "==", true)
    // .where("status", "==", MEMBER_STATUS.NORMAL)
    .orderBy('moved_in_at', 'desc');
  return counselorsRef;
}